import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationRef, NotificationRefControllerService } from '../../core/generated';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationStateService {
  private notificationsUnReadSubject = new BehaviorSubject<NotificationRef[]>([]);
  private notificationsReadSubject = new BehaviorSubject<NotificationRef[]>([]);
  private eventSource: EventSource | undefined;

  notificationsUnRead$ = this.notificationsUnReadSubject.asObservable();
  notificationsRead$ = this.notificationsReadSubject.asObservable();

  constructor(private notificationService: NotificationRefControllerService) {}

  async loadNotifications() {
    const data = await firstValueFrom(this.notificationService.getAllNotifications());
    this.notificationsReadSubject.next(data['read']!);
    this.notificationsUnReadSubject.next(data['unread']!);
  }

  async markAsRead(id: number) {
    await firstValueFrom(this.notificationService.markAsRead(id));
    const unreadNotifications = this.notificationsUnReadSubject.value;
    const notification = unreadNotifications.find(n => n.id === id);
    
    if (notification) {
      const newUnread = unreadNotifications.filter(n => n.id !== id);
      const newRead = [notification, ...this.notificationsReadSubject.value];
      
      this.notificationsUnReadSubject.next(newUnread);
      this.notificationsReadSubject.next(newRead);
    }
  }

  deleteNotification(id: number) {
    this.notificationService.deleteById11(id).subscribe(() => {
      const newRead = this.notificationsReadSubject.value.filter(item => item.id !== id);
      const newUnread = this.notificationsUnReadSubject.value.filter(item => item.id !== id);
      
      this.notificationsReadSubject.next(newRead);
      this.notificationsUnReadSubject.next(newUnread);
    });
  }

  addNewNotification(notification: NotificationRef) {
    const current = this.notificationsUnReadSubject.value;
    this.notificationsUnReadSubject.next([notification, ...current]);
  }

  async initializeStream(email: string) {
    if (this.eventSource) {
      this.eventSource.close();
    }

    this.eventSource = new EventSource(
      `${environment.apiUrl}notificationRef/stream?email=${email}`
    );

    this.eventSource.onmessage = (event) => {
      const notification: NotificationRef = JSON.parse(event.data);
      const currentUnread = this.notificationsUnReadSubject.value;
      this.notificationsUnReadSubject.next([notification, ...currentUnread]);
    };

    this.eventSource.onerror = (error) => {
      console.error('SSE Error:', error);
      this.closeStream();
    };
  }

  closeStream() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = undefined;
    }
  }
}
